var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6921 2.01317C18.9598 2.27246 18.1795 2.44432 17.366 2.52777C18.2029 2.12443 18.8417 1.49061 19.142 0.726654C18.3617 1.10218 17.5001 1.36743 16.582 1.51545C15.841 0.878651 14.785 0.484253 13.633 0.484253C11.398 0.484253 9.59856 1.94859 9.59856 3.74375C9.59856 4.00204 9.62564 4.25041 9.6921 4.48685C6.33578 4.35472 3.36592 3.05628 1.37084 1.07833C1.02253 1.56612 0.818221 2.12443 0.818221 2.72547C0.818221 3.85402 1.53822 4.85442 2.61146 5.4336C1.96284 5.42367 1.32653 5.27167 0.787451 5.03225C0.787451 5.04218 0.787451 5.0551 0.787451 5.06801C0.787451 6.65156 2.18684 7.96689 4.02192 8.26989C3.69331 8.34241 3.33515 8.37718 2.96346 8.37718C2.705 8.37718 2.44407 8.36526 2.19915 8.32155C2.72223 9.61203 4.20654 10.5608 5.97147 10.5916C4.59793 11.4588 2.85392 11.9814 0.965913 11.9814C0.634835 11.9814 0.317296 11.9695 -0.000244141 11.9367C1.78807 12.8676 3.90746 13.399 6.19301 13.399C13.622 13.399 17.6835 8.43182 17.6835 4.12622C17.6835 3.98218 17.6774 3.84309 17.6687 3.705C18.47 3.24603 19.1432 2.67281 19.6921 2.01317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.01855ee4a4e6a8459e8c49ac71b3e1a6.svg";
export { ForwardRef as ReactComponent };